import React from 'react';
import { isRoleAdmin, isUserAgent } from 'src/utils/check-user-is-admin';
import Page403 from 'src/pages/403';

export default function AdminOrAgentGuard({ children }: { children: React.ReactNode }) {
  return isRoleAdmin() || isUserAgent() ? <>{children}</> : <Page403 />;
}
